define('services/config/edgeGroupConfigService',[
    'lib/lodash4',
    'services/apiCore'
], function (_, apiCore) {
    'use strict';

    var INSTANCE_URI = '/telephony/providers/edges/edgegroups';

    var edgeGroupConfigService = {

        /* Instances */
        listInstances: function (options) {
            options = _.assign({ pageSize: 100, pageNumber: 1, filter: '' }, options);
            return apiCore.v2.get(INSTANCE_URI, options);
        }
    };

    return edgeGroupConfigService;
});

